export default __webpack_public_path__ + "static/media/org_parent.b52f048a.svg";